import { IConfig, IContent } from '../types';
import data from '../data/content.json';

const getIsUPC = () => {
  return process.env.REACT_APP_ENV === 'upc';
};

const getCountryCode = () => {
  const localeId =  document.getElementById('root').getAttribute('data-locale');
  return data.filter(
    (locale : IContent) => locale.lang === localeId
  )[0].linkCode;
};

const getOCAPIHost = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'store-staging.ubi.com';
  }

  return window.location.host;
};

const getLang = () => document.documentElement.getAttribute('lang');

const CONFIG: IConfig = {
  clientId : process.env.REACT_APP_OCAPI_CLIENTID,
  isUPC: getIsUPC(),
  countryCode: getCountryCode(),
  lang: getLang(),
  apiHost: getOCAPIHost(),
};
export default CONFIG;
